
import { HighChartBuilder } from "../builders/highchart.builder";
import { StringHelpers } from "../helpers/string-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";

export class ZoomAndScrollButtonComponent implements IComponent {
    public id = StringHelpers.newGuid();;

    private element: HTMLElement | null = null;
    private base: IChartContainer;

    constructor(base: IChartContainer) {
        this.base = base;

        this.createElement();
        this.toggleElement();
        this.base.tiChartSeries?.subscribeRedrawChange(this.id, () => {
            this.toggleElement();
        });
    }

    private onButtonClick() {
        if (!this.element) return;

        this.element.querySelectorAll<HTMLElement>('.bt').forEach((el: HTMLElement) => {
            el.addEventListener('click', () => {
                if (el.classList.contains('plus')) {
                    this.base.tiChartSeries.zoomHandler(1, true);
                } else if (el.classList.contains('minus')) {
                    this.base.tiChartSeries.zoomHandler(-1, true);
                } else if (el.classList.contains('left')) {
                    this.base.tiChartSeries.scrollHandler(-1);
                } else if (el.classList.contains('right')) {
                    this.base.tiChartSeries.scrollHandler(1);
                }
            });
        });
    }

    private toggleElement() {
        if (!this.element) return;

        if (this.base.marketingWebChartMode) {
            const totalInd = this.base.tiChartSeries?.getAllActiveIndicatorOptions()?.filter(x => x.chartAreaName != HighChartBuilder.mainChartAreaName)?.length;
            this.element.classList.remove('one-ind');
            if (totalInd == 1) {
                this.element.classList.add('one-ind');
            }
        }
        if (this.base.tiChartSeries.chartStyleSettings?.zoomAndScrollEnabled &&
            this.base.tiChartSeries.chartStyleSettings?.chartSettingsPopupModel?.displayChartSettingZoomAndScroll) {
            this.setBottomAndActive();
        } else {
            this.element.classList.remove('active');
        }
    }

    private setBottomAndActive() {
        const bottom = this.base.tiChartSeries?.chartStyleSettings?.zoomAndScrollAbsoluteHeight ?? 0;
        this.element.setAttribute('style', `bottom: ${bottom}px`);
        this.element.classList.add('active');
    }

    private createElement() {
        this.element = document.createElement('div');
        this.element.className = 'zoom-and-scroll-button'
        this.element.innerHTML = `
            <div class="wrapper">
                <a href="javascript:void(0)" class="bt plus" title="Zoom in">
                    <div class="ico">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                            <path d="M4 12H20M12 4V20" stroke="#3C4A59" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </a>
                <a href="javascript:void(0)" class="bt minus" title="Zoom out">
                    <div class="ico">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                            <path d="M6 12L18 12" stroke="#3C4A59" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </a>
                <a href="javascript:void(0)" class="bt left" title="Scroll left">
                    <div class="ico">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14px" height="14px" viewBox="-4.5 0 20 20" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g transform="translate(-345.000000, -6679.000000)" fill="#3C4A59">
                                    <g transform="translate(56.000000, 160.000000)">
                                        <path d="M299.633777,6519.29231 L299.633777,6519.29231 C299.228878,6518.90256 298.573377,6518.90256 298.169513,6519.29231 L289.606572,6527.55587 C288.797809,6528.33636 288.797809,6529.60253 289.606572,6530.38301 L298.231646,6538.70754 C298.632403,6539.09329 299.27962,6539.09828 299.685554,6538.71753 L299.685554,6538.71753 C300.100809,6538.32879 300.104951,6537.68821 299.696945,6537.29347 L291.802968,6529.67648 C291.398069,6529.28574 291.398069,6528.65315 291.802968,6528.26241 L299.633777,6520.70538 C300.038676,6520.31563 300.038676,6519.68305 299.633777,6519.29231"></path>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                </a>
                <a href="javascript:void(0)" class="bt right" title="Scroll right">
                    <div class="ico">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14px" height="14px" viewBox="-4.5 0 20 20" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g transform="translate(-305.000000, -6679.000000)" fill="#3C4A59">
                                    <g transform="translate(56.000000, 160.000000)">
                                        <path d="M249.365851,6538.70769 L249.365851,6538.70769 C249.770764,6539.09744 250.426289,6539.09744 250.830166,6538.70769 L259.393407,6530.44413 C260.202198,6529.66364 260.202198,6528.39747 259.393407,6527.61699 L250.768031,6519.29246 C250.367261,6518.90671 249.720021,6518.90172 249.314072,6519.28247 L249.314072,6519.28247 C248.899839,6519.67121 248.894661,6520.31179 249.302681,6520.70653 L257.196934,6528.32352 C257.601847,6528.71426 257.601847,6529.34685 257.196934,6529.73759 L249.365851,6537.29462 C248.960938,6537.68437 248.960938,6538.31795 249.365851,6538.70769"></path>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                </a>
            </div>
        `;

        this.base.element.insertAdjacentElement('beforeend', this.element);
        this.base.element.addEventListener('mouseleave', () => {
            this.element.classList.remove('hover');
        });
        this.base.element.addEventListener('mousemove', (event) => {
            const target = event.target as HTMLElement;
            if (target && typeof target.closest !== 'undefined' && !!target.closest('.settings-popup')) {
                return;
            }

            const rect = this.element.getBoundingClientRect();

            // Calculate the center of the box
            const boxCenterX = rect.left + rect.width / 2;
            const boxCenterY = rect.top + rect.height / 2;

            // Calculate the distance from the mouse to the center of the box
            const distance = Math.sqrt(
                Math.pow(event.clientX - boxCenterX, 2) +
                Math.pow(event.clientY - boxCenterY, 2)
            );

            // Check if the distance is less than or equal to 30px
            if (distance <= 120) {
                this.element.classList.add('hover');
            } else {
                this.element.classList.remove('hover');
            }
        });

        setTimeout(() => {
            this.onButtonClick();
        }, 200);
    }
}